import { detectarPlataforma } from "../game/saves/escolha";

/**
 * Abre um endereço de fora do jogo no navegador do sistema.
 *
 * No computador vai pelo plugin `opener` do Tauri: o `window.open` da WebView
 * abriria uma janela solta, sem barra de endereço, e o checkout de pagamento é
 * justamente onde a pessoa precisa ver o endereço e o cadeado. A permissão do
 * plugin só aceita `https://`.
 *
 * No navegador e no Android é `window.open`. Sem `noopener` na lista de
 * recursos de propósito: com ele o navegador devolve `null` mesmo abrindo a
 * aba, e não daria para saber se o bloqueador de pop-up agiu. O `opener` é
 * cortado à mão logo em seguida, que é o que o `noopener` protegeria.
 *
 * Devolve se conseguiu abrir.
 */
export async function abrirFora(endereco: string): Promise<boolean> {
  if (detectarPlataforma() === "tauri") {
    try {
      const { openUrl } = await import("@tauri-apps/plugin-opener");
      await openUrl(endereco);
      return true;
    } catch {
      return false;
    }
  }
  const aba = window.open(endereco, "_blank");
  if (!aba) return false;
  aba.opener = null;
  return true;
}
